<template>
	<div class="sm_star">
			<div v-if="file" class="mdc-dialog" data-mdc-auto-init="MDCDialog" style="display: block; z-index:999;">
			<div id="attched-close-button" class="attched-close-button" style="z-index:999;">
				<img alt="" class="cursor-pointer w-48 h-48 attched-close-button" src="/images/close-button.svg" tabindex="0" @click="hideImage" @keypress="hideImage">
			</div>
			<div class="mdc-dialog__container" style="opacity:1; transform: scale(1);">
				<div aria-modal="true" class="mdc-dialog__surface home-modal" role="alertdialog">
					<img v-if="getType(file.contentType) === 'image'" id="modal-image" :alt="file.originalName" :src="file.resourceUri" class="b-radius4"/>
					<video-player
							v-if="getType(file.contentType) === 'video'"
							ref="videoPlayer"
							:options="getPayerOption(file)"
							:playsinline="true"
							class="video-player-box preview-video-new"
					/>
				</div>
			</div>
			<div class="mdc-dialog__scrim" style="opacity:1;" tabindex="0" @click="hideImage" @keypress="hideImage"></div>
		</div>
	</div>
</template>

<script>
import TopAppBar from '@/components/TopAppBar.vue';
import {topAppBarMixin} from '../../mixins/topAppBar.js';
import 'video.js/dist/video-js.css';
import { videoPlayer } from 'vue-video-player';
import { MDCRipple } from '@material/ripple';
export default {
	components: {
			videoPlayer,
			TopAppBar,
  },

  mixins: [topAppBarMixin],

  props: ['file'],

  mounted() {
		this.setTopAppBarCloseSocialPopup('');
		this.setMaterialUi();
	},

	methods : {
		getType(contentType) {
			return contentType.split('/')[0]
		},

		hideImage() {
		this.$emit('closePopup');
		},

		getPayerOption(img) {
			return {
				language: 'en',
				controls: true,
				playbackRates: [0.7, 1.0, 1.5, 2.0],
				sources: [{
				type: img.contentType,
				src: img.resourceUri
				}],
				height: 360,
				width: 'auto'
			}
		},

		setMaterialUi() {
				const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
						let button = new MDCRipple.attachTo(el)
						return button
				})
			},
	}
}
</script>
<style scoped>
#modal-image {
  max-height: 766px !important;
  max-width: 766px !important;
}

.home-modal{
	min-width: auto !important;
	background:transparent !important;
	box-shadow: none !important;
}

.home-modal .video-js{
	background:transparent !important;
	right: 0 !important;
}

.vjs-text-track-display{
	position:absolute !important;
}
</style>
